module.exports = __webpack_public_path__ + "img/daily-footer.96ae01a2.png";